module.exports = __webpack_public_path__ + "static/img/he.0948d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/he.png
// module id = Wccg
// module chunks = 0